export const isTextValidNonNegativeNumber = (numberAsString: string) => {
    const numericValue = Number(numberAsString);

    return numberAsString.toString() === numberAsString && numericValue >= 0;
};
